import { useState } from 'react';

import { Box, Button, Checkbox, FormControlLabel, TextField, Typography } from '@mui/material';

interface FileProcessingConfig {
  deleteAfterProcessing?: boolean;
  filePattern?: string;
  archivePath?: string;
}

interface WizardSFTPFileProcessingStepProps {
  onNext: (config: FileProcessingConfig) => void;
  onSaveAndExit?: () => void;
  initialFileProcessing?: FileProcessingConfig;
}

export const WizardSFTPFileProcessingStep = ({
  onNext,
  onSaveAndExit,
  initialFileProcessing = {},
}: WizardSFTPFileProcessingStepProps) => {
  const [deleteAfterProcessing, setDeleteAfterProcessing] = useState(
    initialFileProcessing.deleteAfterProcessing || false
  );
  const [filePattern, setFilePattern] = useState(initialFileProcessing.filePattern || '');
  const [archivePath, setArchivePath] = useState(initialFileProcessing.archivePath || '');

  const handleNext = () => {
    onNext({
      deleteAfterProcessing,
      filePattern,
      archivePath,
    });
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        SFTP File Processing
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Configure how files should be processed after transfer
      </Typography>

      <TextField
        fullWidth
        label="File Pattern"
        value={filePattern}
        onChange={(e) => setFilePattern(e.target.value)}
        placeholder="*.csv"
        helperText="Pattern to match files (e.g., *.csv, data-*.json)"
        sx={{ mb: 2 }}
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={deleteAfterProcessing}
            onChange={(e) => setDeleteAfterProcessing(e.target.checked)}
          />
        }
        label="Delete files after processing"
        sx={{ mb: 2 }}
      />

      {!deleteAfterProcessing && (
        <TextField
          fullWidth
          label="Archive Path"
          value={archivePath}
          onChange={(e) => setArchivePath(e.target.value)}
          placeholder="/archive"
          helperText="Path to move processed files"
          sx={{ mb: 2 }}
        />
      )}

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 4 }}>
        {onSaveAndExit && (
          <Button variant="outlined" onClick={onSaveAndExit}>
            Save and Exit
          </Button>
        )}
        <Button variant="contained" onClick={handleNext}>
          Next
        </Button>
      </Box>
    </Box>
  );
};
